import { BottomDrawer, Button } from '@zenterprise-inc/ui';
import React, { useState } from 'react';

const DESCRIPTIONS_TEXT = [
  '배우자(현재뿐 아니라 과거, 사실혼 관계도 포함)',
  '6촌 이내의 혈족(부모, 조부모, 자녀, 손자녀, 형제자매, 부모의 형제자매, 조카 등)',
  '4촌 이내의 인척(배우자의 부모,형제자매, 삼촌, 고모, 이모, 조카, 형제자매의 배우자, 자녀의 배우자)'
];
const listBulletStyle = 'before:contents-[""] before:inline-block before:shrink-0 before:w-1 before:h-1 before:bg-gray-700 before:mt-2 before:rounded-full';

export const SpecialRelationshipsDescription = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <>
      <div className={'flex gap-x-[5px] py-3'}>
        <div className={'self-start inline-flex shrink-0'}>
          <InfoIcon />
        </div>

        <p className={'text-[13px] text-gray-600 leading-[18px]'}>
          <button type={'button'} className={'text-blue-600'} onClick={() => setOpenDrawer(true)}>
            특수관계인이란?
          </button>{' '}
          배우자(이혼, 재혼, 사실혼 포함)와 6촌 이내의 혈족, 4촌 이내의 인척을 말해요.
        </p>
      </div>

      <BottomDrawer.Basic isVisible={openDrawer} onCloseDrawer={() => setOpenDrawer(false)}>
        <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={() => setOpenDrawer(false)}>
          특수관계인이란?
        </BottomDrawer.Basic.Header>
        <BottomDrawer.Basic.Contents className={'pt-3 !pb-[128px] px-6'}>
          <ul className={'flex flex-col gap-y-2 body-14 text-gray-700'}>
            {DESCRIPTIONS_TEXT.map((text) => (
              <li key={text} className={`flex gap-x-2 ${listBulletStyle}`}>
                {text}
              </li>
            ))}
          </ul>
        </BottomDrawer.Basic.Contents>
        <BottomDrawer.Basic.BottomButton>
          <Button.StickyBottom.Button state={'primary'} onClick={() => setOpenDrawer(false)}>
            확인했어요
          </Button.StickyBottom.Button>
        </BottomDrawer.Basic.BottomButton>
      </BottomDrawer.Basic>
    </>
  );
};

const InfoIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.78847 5.01866C8.78847 5.45424 8.43536 5.80734 7.99979 5.80734C7.56421 5.80734 7.21111 5.45424 7.21111 5.01866C7.21111 4.58309 7.56421 4.22998 7.99979 4.22998C8.43536 4.22998 8.78847 4.58309 8.78847 5.01866Z"
        fill="#707F8F"
      />
      <path d="M7.32091 11.0186H6.49121V11.7728H9.50835V11.0186H8.67862V6.49284H6.49121V7.24712H7.32091V11.0186Z" fill="#707F8F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016ZM13.6663 8.00016C13.6663 11.1298 11.1293 13.6668 7.99967 13.6668C4.87006 13.6668 2.33301 11.1298 2.33301 8.00016C2.33301 4.87055 4.87006 2.3335 7.99967 2.3335C11.1293 2.3335 13.6663 4.87055 13.6663 8.00016Z"
        fill="#707F8F"
      />
    </svg>
  );
};
